// @flow

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { WS_GET_PAYPAL_USER_DATA_REQUEST } from '../../../store/actions';
import { useQuery } from '../../shared';

export const PaypalDataCallback = () => {
  const query = useQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    if (query.get('code')) {
      dispatch({ type: WS_GET_PAYPAL_USER_DATA_REQUEST, payload: query.get('code') });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return null;
};
